module.exports = __webpack_public_path__ + "assets/img/9_57.85ad6573.jpg";